import React, { PureComponent } from 'react';
import {
  string, func, object, node,
} from 'prop-types';
import omit from 'lodash/omit';

import { MessageProducer, listenEventMessage } from './messageHandlers';

class IFrame extends PureComponent {
  static propTypes = {
    title: string.isRequired,
    defaultMessage: object,
    origin: string,
    listener: func,
    messageFormatter: func,
    children: node,
  }

  componentDidMount() {
    const { listener } = this.props;
    this.startListen(listener);
  }

  componentWillUnmount() {
    this.unlisten && this.unlisten();
  }

  componentDidUpdate({ listener: prev }) {
    const { listener: current } = this.props;
    prev !== current && this.startListen(current);
  }

  startListen(listener) {
    const { messageFormatter, messageType, originRegExStr } = this.props;
    this.unlisten && this.unlisten();
    this.unlisten = listenEventMessage({
      listener, messageFormatter, messageType, originRegExStr,
    });
  }

  postMessage = (...args) => {
    const { defaultMessage, origin } = this.props;
    if (!this.messageProducer) {
      this.messageProducer = new MessageProducer({
        target: this.iframe, defaultMessage, origin,
      });
    }
    this.messageProducer(...args);
  }

  render() {
    const {
      title, children,
    } = this.props;
    const rest = omit(this.props, [ 'defaultMessage', 'origin', 'listener', 'messageFormatter', 'title', 'children' ]);

    return (
      <React.Fragment>
        <iframe {...rest} title={title} ref={(iframe) => { this.iframe = iframe; }}/>
        {children}
      </React.Fragment>
    );
  }
}

export default IFrame;
